import * as R from 'ramda';

export function matchSearchOnProps(searchString, props) {
  const matchers = getLowerCaseMatchers(searchString);
  return item => {
    const searchValues = props.map(prop => item[prop]);
    const matchesSearchValues = m => R.any(m, searchValues);
    return R.all(matchesSearchValues, matchers);
  };
}

function getLowerCaseMatchers(searchString) {
  const parts = searchString ? searchString.trim().split(/[\s.,]+/) : [];
  return parts.map(matchesLowerCase);
}

const wordBoundary = "(^|[^a-zöäåü])";
const specialChars = /([()^$.{\\\\])/g;

export function matchesLowerCase(filter) {
  if (!filter) return R.always(true);
  const wordStartsWithFilter = new RegExp(
    wordBoundary+filter.replace(specialChars, "\\$1"), "i"
  );

  return (value) => {
    if (R.isNil(value)) return false;
    //Convert number values to strings
    return String(value).match(wordStartsWithFilter) != null;
  };
}



// WEBPACK FOOTER //
// ./modules/issFrontend/utils/search.js